<template>
  <div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="showModal = true">
            <feather-icon
              icon="PlusIcon"
              class="mr-50"/>
            <span class="align-middle">{{$t('add')}}</span>
          </b-button>
        <vs-divider />
        <Grid
          ref="dataAccessGrid"
          :key="gridKey"
          :service="dataAccessService"
          route_name="data_accesses"
          :route_grid_path="dataAccessesGridPath"
          hide_edit="true"
          :delegate="{destroy: () => removeRoleDataAccess}"
        >
          <template v-slot:gridThead>
            <vs-th key="legal_entity_name">Instituição</vs-th>
            <vs-th key="role_name">Grupo</vs-th>
            <vs-th key="role_description">Descrição Grupo</vs-th>
          </template>
          <template v-slot:gridActions>
            <vs-th key="actions">Ações</vs-th>
          </template>
          <template v-slot:gridData="props">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
              <vs-td width="30%" key="id">{{ tr.entity.legal_entity_name ? tr.entity.legal_entity_name : '--'  }}</vs-td>
              <vs-td width="20%" key="role_name">{{ tr.entity && tr.entity.display_name }}</vs-td>
              <vs-td width="40%" key="role_description">{{tr.entity && tr.entity.description}}</vs-td>
              <vs-td width="5%" key="actions">
                <div class="flex items-center justify-center">
                  <feather-icon
                    icon="Trash2Icon"
                    class="h-5 w-5 mb-1 stroke-current text-danger "
                    @click="props.destroy(props.data[indextr])"
                    v-tooltip.top="{
                      content: 'Excluir',
                      delay: { show: 1000, hide: 100 }
                    }"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </Grid>
      </div>
    </div>

    <vs-popup title="Grupos" :active.sync="showModal">
      <Grid
        :service="roleService"
        :delegate="{itemSelected: () => addRoleDataAccess} "
        route_name="roles"
        hide_actions="true"
        v-if="showModal"
      ></Grid>
    </vs-popup>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue'
//
import { ValidationProvider, ValidationObserver } from 'vee-validate'
//
import RoleService from '@/services/api/RoleService'
import DataAccessService from '@/services/api/DataAccessService'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
  },
  props: {
    modelType: {
      type: String,
      default: null
    },
    modelId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    roleService: null,
    dataAccessService: null,
    showModal: false,
    gridKey: 0
  }),
  computed: {
    dataAccessesGridPath() {
      return `${this.model.type}/${this.model.id}/roles/grid`
    },
    model() {
      return {
        id: this.modelId,
        type: this.modelType
      }
    },
  },
  methods: {
    addRoleDataAccess(role) {
      if (role) {
        this.$vs.loading()
        this.dataAccessService
          .modelAddRole(role.id, this.model)
          .then(
            response => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Successo!',
                text: 'Operação realizada com sucesso.',
                color: 'success',
                iconPack: 'feather',
                position: 'top-center',
                icon: 'icon-check-circle'
              })

              this.gridKey += 1
            },
            error => {
              this.$vs.loading.close()
              this.notifyError(this.$vs, 'Não foi possível incluir este grupo!')
            }
          )
      }
      this.showModal = false
    },
    removeRoleDataAccess(dataAccess) {
      this.$vs.loading()
      return this.dataAccessService.modelRemoveRole(dataAccess.entity.id, this.model).then(
        response => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Successo!',
            text: 'Operação realizada com sucesso.',
            color: 'success',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-check-circle'
          })

          this.gridKey += 1
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, 'Não foi possível remover este grupo!')
        }
      )
    }
  },

  beforeMount() {
    this.roleService = RoleService.build(this.$vs)
    this.dataAccessService = DataAccessService.build(this.$vs)
  }
}
</script>
